import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["data-test", "kind", "size", "centered"];
import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './Spinner.styles';

var Spinner = function Spinner(_ref) {
  var dataTest = _ref['data-test'],
      kind = _ref.kind,
      size = _ref.size,
      centered = _ref.centered,
      props = _objectWithoutProperties(_ref, _excluded);

  var strokeWidth = size <= 50 ? 5 : 3;
  return /*#__PURE__*/React.createElement(Styled.Spinner, _extends({
    "aria-busy": "true",
    "data-test": dataTest,
    size: size,
    centered: centered
  }, props), /*#__PURE__*/React.createElement(Styled.SVG, {
    viewBox: "0 0 100 100",
    size: size
  }, /*#__PURE__*/React.createElement(Styled.Circle, {
    kind: kind,
    cx: "50",
    cy: "50",
    r: "20",
    fill: "none",
    strokeWidth: strokeWidth,
    strokeMiterlimit: "10"
  })));
};

Spinner.displayName = 'Spinner';
Spinner.propTypes = {
  /**
   * Specify the kind of spinner - default (red) or white
   */
  kind: PropTypes.oneOf(['default', 'white', 'green']),

  /**
   * Specify the whether the spinner is centered within its container (absolutely positioned - take care!)
   */
  centered: PropTypes.bool,

  /**
   * Specify the size of the spinner (width and height have the same value)
   */
  size: PropTypes.number,

  /**
   * Specify an optional data-test attribute to be added to your Spinner for e2e testing
   */
  'data-test': PropTypes.string
};
Spinner.defaultProps = {
  size: 100,
  kind: 'default',
  centered: false
};
export default Spinner;